import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { getBackendUrl, failedResponse, loaded, notStarted, LoadStateInfo, loading, error } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { RootState } from "../../app/store";

// Thunk for deleting an image by id
export const imageDelete = createAsyncThunk(
  "image/delete",
  async (params: { imageId: string }, thunkAPI) => {
    const response = await fetch(`${getBackendUrl()}/api/image/${params.imageId}`, {
      method: "DELETE",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      return params.imageId;
    } else {
      return thunkAPI.rejectWithValue(failedResponse(response));
    }
  }
);

export interface ImageState {
  state: LoadStateInfo;
  selected?: ImageInfo;
}

const initialState: ImageState = {
  state: notStarted(),
};

export const imageSlice = createSlice({
  name: "image",
  initialState,
  reducers: {
    select: (state, action: PayloadAction<ImageInfo | undefined>) => {
      console.trace(`select :: ${action.payload?.id}`);
      state.state = loaded();
      state.selected = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.selected = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(imageDelete.pending, (state) => {
        state.state = loading();
      })
      .addCase(imageDelete.fulfilled, (state, action) => {
        if (state.selected && state.selected.id === action.payload) {
          state.selected = undefined;
        }
        state.state = loaded();
      })
      .addCase(imageDelete.rejected, (state, action) => {
        state.state = error(action);
      });
  },
});

export interface ImageInfo {
  id: string;
  schoolId: string;
  createdAt?: string;
  updatedAt?: string;
  privateImage?: number;
  imageStatus?: number;
}

// export const { } = imageSlice.actions;

export const selectImage = (state: RootState) => state.image;

export default imageSlice.reducer;
